<template>
  <el-card class="box-card main-card">
    <el-button v-if="$route.query.userId" size="mini" class="pxy-primary return-button" style="margin-right: 10px;" @click="$router.go(-1)">返回</el-button>
    <el-form class="search-form" ref="form" :model="searchForm" label-width="85px" inline>
      <el-form-item label="创建时间：">
        <el-select v-model="searchForm.periodIndex"
                   @change="searchFn"
                   placeholder="" style="width:120px">
          <el-option
            v-for="(item,index) in periods"
            :key="index"
            :label="item.label"
            :value="index">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="类型：">
        <el-select v-model="searchForm.type"
                   @change="searchFn"
                   placeholder="" style="width:120px">
          <el-option
            v-for="(item,index) in type"
            :key="index"
            :label="item.value"
            :value="item.key">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名称：" v-if="$route.query.userName">
        <el-tag effect="plain">{{$route.query.userName}}</el-tag>
      </el-form-item>
    </el-form>
    <template>
      <el-table
        :data="tableData"
        :row-class-name="tableRowClassName"
        style="width: 100%">
        <el-table-column
          prop="amount"
          label="金额">
          <template slot-scope="scope">
            <span>￥{{Math.abs(scope.row.amount)}}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="note"
          label="来源">
        </el-table-column>
        <el-table-column
          label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type == 0 && scope.row.amount > 0">充值</span>
            <span v-if="scope.row.type == 1 || scope.row.amount < 0">消费（包期）</span>
            <span v-if="scope.row.type == 2">消费（按量）</span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间">
          <template slot-scope="scope">
            {{scope.row.createDate | formatDate}}
          </template>
        </el-table-column>

      </el-table>
    </template>
    <PageComponent ref="pageInfo"></PageComponent>

  </el-card>

</template>

<script>
  import PageComponent from '@/components/pageInfo/PageComponent'
  import {Message} from "element-ui";

  export default {
    components: {PageComponent},
    data() {
      return {
        searchForm: {
          periodIndex:'',
          type:"0"
        },
        periods: [],
        type:[
          {key:"0",value:"充值"},
          {key:"1",value:"消费（包期）"},
          {key:"2",value:"消费（按量）"}
        ],
        tableData:[],
      }
    },
    beforeCreate(){

    },
    created() {
      this.getSearchPeriod()
    },
    methods: {
      getAccountLog: function () {
        var params = {};
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        params.type = this.searchForm.type;
        params.startTime = this.periods[this.searchForm.periodIndex].beginDate;
        params.endTime = this.periods[this.searchForm.periodIndex].overDate;
        this.getRequest('/ofcAccountLog/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.tableData = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total);
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      searchFn() {
        var queryStr = JSON.parse(JSON.stringify(this.$route.query));
        queryStr.page = 1;
        this.$router.push({query: queryStr});
        if(this.$route.query.userId){ // 收支明细查询 - （用户管理菜单页跳转过来）
          this.getUserAccountLog();
        }else {
          this.getAccountLog();
        }
      },
      getSearchPeriod() {
        //创建现在的时间
        let date = new Date();
        //获取年
        let year = date.getFullYear();
        //获取月
        let mon = date.getMonth() + 1;
        var period1 = {}, period2 = {}, period3 = {}, period4 = {}, period5 = {};
        //近6个月
        period1.label = "近6个月";
        period1.beginDate = this.getDate(year, mon, 6);
        if(mon == 12){
          period1.overDate = new Date(parseInt(year + 1) + "/" + mon + '/01').getTime();
        }else {
          period1.overDate = new Date(year + "/" + parseInt(mon + 1) + '/01').getTime();
        }
        this.periods.push(period1)
        //近一年
        period2.label = "近一年";
        period2.beginDate = this.getDate(year, mon, 12);
        if(mon == 12){
          period2.overDate = new Date(parseInt(year + 1) + "/" + mon + '/01').getTime();
        }else{
          period2.overDate = new Date(year + "/" + parseInt(mon + 1) + '/01').getTime();
        }
        this.periods.push(period2)
        //去年
        period3.label = parseInt(year - 1);
        period3.beginDate = new Date(parseInt(year - 1) + "/01" + '/01').getTime();
        period3.overDate = new Date(year + "/01" + '/01').getTime();
        this.periods.push(period3)
        //前年
        period4.label = parseInt(year - 2);
        period4.beginDate = new Date(parseInt(year - 2) + "/01" + '/01').getTime();
        period4.overDate = new Date(parseInt(year - 1) + "/01" + '/01').getTime();
        this.periods.push(period4)
        //大前年
        period5.label = parseInt(year - 3);
        period5.beginDate = new Date(parseInt(year - 3) + "/01" + '/01').getTime();
        period5.overDate = new Date(parseInt(year - 2) + "/01" + '/01').getTime();
        this.periods.push(period5)
        this.searchForm.periodIndex = 0;
      },
      getDate(year, month, minus) {
        month = month - minus;
        if (month <= 0) {
          year = year - 1;
          month = month + 12;
        }
        if (month < 10) {
          month = "0" + month;
        }

        return new Date(year + "/" + month + '/01').getTime();
      },
      getUserAccountLog() {
        var params = {
          page: this.$refs.pageInfo.currentPage,
          pageSize: 10,
          type : this.searchForm.type,
          startTime: this.periods[this.searchForm.periodIndex].beginDate,
          endTime: this.periods[this.searchForm.periodIndex].overDate,
          userId: this.$route.query.userId
        };
        this.getRequest('/ofcAccountLog/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.tableData = resp.data.result.records;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total);
            } else {
              Message.error(resp.data.message);
            }
          } else {
            console.error("error")
          }
        })
      },
      tableRowClassName({row, rowIndex}) {
        console.log(row)
        if (row.type == 0 && row.amount > 0) {
          return 'success-row';
        } else  {
          return 'error-row';
        }
        return '';
      }
    },
    mounted: function () {
      if(this.$route.query.userId){ // 收支明细查询 - （用户管理菜单页跳转过来）
        this.$refs.pageInfo.initPagenator(this.getUserAccountLog, 10);
        this.getUserAccountLog();
      } else {
        this.$refs.pageInfo.initPagenator(this.getAccountLog, 10);
        this.getAccountLog()
      }
    },
    beforeDestroy() {}
  }
</script>
<style>
  .el-table .warning-row {
    background: oldlace;
  }
  .el-table .error-row {
    background: rgb(253,226,226);
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>

